// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2be7f7413cca977b3ece51116b71443356500a6f/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};